/* ============================================================
   Build #250 (GEO) — sanaston ankkurilinkit
   ------------------------------------------------------------
   Sanastosivun accordionit ovat `collapse-all`-tilassa kiinni
   (Build #247). Ilman tata skriptia deep-link muotoa
   /pages/ingredient-glossary#squalane vie oikeaan kohtaan mutta
   sisalto jaa piiloon — linkki nayttaa rikkinaiselta.

   Avaa osuvan accordionin sivulatauksessa ja hashchange-eventissa.
   Atlantic togglaa `.active`-luokkaa seka otsikossa etta
   sisaltodivissa, joten sama tehdaan tassa.
   ============================================================ */
(function () {
  'use strict';

  function openFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (e) {
      id = hash.slice(1);
    }

    var heading = document.getElementById(id);
    if (!heading || !heading.classList.contains('faq__heading')) return;

    var content = heading.nextElementSibling;
    heading.classList.add('active');
    if (content && content.classList.contains('faq__content')) {
      content.classList.add('active');
    }

    // Selain on jo vierittanyt ennen kuin sisalto avautui — korjataan.
    window.requestAnimationFrame(function () {
      heading.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
  window.addEventListener('hashchange', openFromHash);
})();
